module.exports = {
	"tasks": "TASKS",
	"tasks_not_started": "Not Started",
	"tasks_in_progress": "In Progress",
	"tasks_in_review": "In Review",
	"all_projects_overview": "PROJECTS OVERVIEW",
	"search_all_projects_overview": "Search Projects Overview",
	"total_projects": "TOTAL PROJECTS",
	"map_my_day": "MAP MY DAY",
	"tasks_completed": "Tasks Completed",
	"task_quality": "Task Quality",
	"vs_this_time_last_week": "vs. this time last week"
};


//////////////////
// WEBPACK FOOTER
// ./public/locales/en/user_dashboard.json
// module id = 2009
// module chunks = 0